import _t from 'i18n!nls/author-gradebook';

const hasSeparateFirstLastNames = (data: $TSFixMe) => {
  return data.valueSeq().some((learner: $TSFixMe) => learner.get('userFirstName') && learner.get('userLastName'));
};

const hasUniversityId = (data: $TSFixMe) => {
  return data.valueSeq().some((learner: $TSFixMe) => learner.get('userExternalId'));
};

// List of potential learner identifying columns (ie name or id). Each column has the following structure
// {
//  getLabel: () => string, function for getting translated UI string for the column header
//  includeCondition: (gradebookData) => boolean, function to determine if we show the column or not.
//  dataKey: string, the key in the Back End data structure for getting the data for this column
//  sortPriority: number, the highest included number will be default sorted
// }
const learnerColumnConfigs = [
  {
    getLabel: () => _t('Name'),
    includeCondition: (data: $TSFixMe) => !hasSeparateFirstLastNames(data),
    dataKey: 'userName',
    sortPriority: 1,
  },
  {
    getLabel: () => _t('First Name'),
    includeCondition: hasSeparateFirstLastNames,
    dataKey: 'userFirstName',
    sortPriority: 0,
  },
  {
    getLabel: () => _t('Last Name'),
    includeCondition: hasSeparateFirstLastNames,
    dataKey: 'userLastName',
    sortPriority: 3,
  },
  {
    getLabel: () => _t('Student Id'),
    includeCondition: hasUniversityId,
    dataKey: 'userExternalId',
    sortPriority: 4,
  },
];

export default learnerColumnConfigs;
